import config from "config";
import "./logo.scss";
import {Link} from "react-router-dom";
import {PUBLIC_HOME_PAGE} from "../../../../constants/paths";

const Logo = () => {

    const logo = require(`images/logo/${config.location}.svg`);
    
    return (
        <Link to={PUBLIC_HOME_PAGE} className="logo-wrapper">
          <img src={logo} alt="Logo" />
        </Link>
    )
}

export default Logo;